import React, { useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useHistory } from "react-router";
import { Image, Col, Row, Table } from "react-bootstrap";
import Switch from "react-switch";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import SuperAdminDeleteOffer from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteOffer";
import { PopupActionButton } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import MobileVendorEditOfflineOffer from "./EditOffer/MobileVendorEditOfflineOffer";
import { AuditLogsheaderTable } from "../../reusableComponents/allTableReusable/auditLogTable/AuditLogsheaderTable";
import { AuditLogsBodyTable } from "../../reusableComponents/allTableReusable/auditLogTable/AuditLogsBodyTable";
import isEmpty from "../../../store/validation/is-Empty";

const MobileViewOfferDetailsOffline = (props) => {
  // const history = useHistory();
  //state
  const [showMoreDetail, setShowMoreDetail] = useState(false);
  const [state, setState] = useState({
    open: false,
  });
  // const handleShowMoreDetail = () => {
  //   setShowMoreDetail({
  //     showMoreDetail: !showMoreDetail.showMoreDetail,
  //   });
  // };
  // const [checked, setChecked] = useState(false);
  const [showView, setShowView] = useState(false);
  const toggleFunction = (e) => {
    // setChecked({ checked: !checked.checked });
    // console.log("test");
  };
  const [showLog, setShowLog] = useState(false);
  const handleShowLog = () => {
    setShowLog(!showLog);
  };

  const onOpenModal = () => {
    setState({
      open: true,
    });
  };
  const onCloseModal = () => {
    setState({
      open: false,
    });
  };
  // const handleShowView = () => {
  //   setShowView(true);
  // };

  const handleCloseView = () => setShowView(false);
  const renderAuditViewDetails = () => {
    if (!isEmpty(props.vendorOffer.auditLogs)) {
      return props.vendorOffer.auditLogs.map((data, index) => (
        <React.Fragment key={index}>
          <AuditLogsBodyTable
            date={moment(data.timestamp).format("Do MMM, YYYY")}
            time={moment(data.timestamp).format("hh:mm A")}
            message={data.message}
            by={data.initiator}
          />
        </React.Fragment>
      ));
    }
  };

  return (
    <>
      <React.Fragment>
        {props.mobileButton ? (
          <PopupActionButton
            buttonText={"View"}
            buttonType="button"
            buttonClass="smallblue"
            onClick={onOpenModal}
          />
        ) : (
          <div className="enIconBtn mr-3" onClick={onOpenModal}>
            <Image
              src={require("../../../assets/images/UserManagement/eye.svg")}
              alt="Edit"
              title="Edit"
              fluid
            />
          </div>
        )}
        <Modal
          open={state.open}
          onClose={onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "offer-event-main closeRemove min-height-100vh w-100",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="d-flex align-items-center py-3 px-4 border-bottom">
            <span className="pr-3 cursor" onClick={onCloseModal}>
              <Image
                alt="Back"
                width="20px"
                src={require("../../../assets/images/UserManagement/backIcon.svg")}
              />
            </span>
            <div className="f12-400 c_black">View Offer</div>
          </div>
          <div className="col-12 py-3">
            <div className="f12-400 opacity5">Offer Name</div>
            <div className="d-flex align-items-center pt-2 pb-3">
              <div className="f16-500">
                {props.vendorOffer && props.vendorOffer.name}
              </div>
              <div className="enPendingLBL ml-2">Offline</div>
            </div>
            <div className="f12-400 opacity5">Description</div>
            <div className="pt-2 f12-400">
              {props.vendorOffer && props.vendorOffer.description}
            </div>
            <div className="d-flex pt-3">
              <MobileVendorEditOfflineOffer data={props.data} />
              <SuperAdminDeleteOffer
                // offerId={props.vendorOffer && props.vendorOffer._id}
                handleCloseView={handleCloseView}
                actionBy={"vendor"}
                insideDelete={"viewDelete"}
                offerId={props.vendorOffer._id}
              />
            </div>
          </div>
          <Row className="mx-0">
            <Col xs={6} className="py-3 border-top border-right">
              <div className="pb-2 f12-400 opacity5">Status</div>
              <div className="d-flex align-items-center">
                <div className="f14-500 mr-2">Inactive</div>
                <Switch
                  onChange={toggleFunction}
                  checked={props.vendorOffer && props.vendorOffer.active}
                  offColor="#EEEEEE"
                  onColor="#EEEEEE"
                  offHandleColor="#212121"
                  onHandleColor="#59F832"
                  handleDiameter={24}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={15}
                  width={41}
                  boxShadow="-2px 0px 5px #0000003B"
                  activeBoxShadow="-2px 0px 5px #0000003B"
                  id="material-switch"
                />
              </div>
            </Col>
            <Col xs={6} className="py-3 border-top">
              <div className="pb-2 f12-400 opacity5">Primary Status</div>
              <div className="d-flex align-items-center">
                <div className="f14-500 mr-2">No</div>
                <Switch
                  onChange={toggleFunction}
                  checked={
                    props.vendorOffer && props.vendorOffer.mark_as_primary
                  }
                  offColor="#EEEEEE"
                  onColor="#EEEEEE"
                  offHandleColor="#212121"
                  onHandleColor="#59F832"
                  handleDiameter={24}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={15}
                  width={41}
                  boxShadow="-2px 0px 5px #0000003B"
                  activeBoxShadow="-2px 0px 5px #0000003B"
                  id="material-switch"
                />
                <div className="f14-500 ml-2">Yes</div>
              </div>
            </Col>
            <Col xs={6} className="py-3 border-top border-right">
              <div className="pb-2 f12-400 opacity5">Start Date</div>
              <div className="d-flex align-items-center">
                <Image
                  src={require("../../../assets/images/UserManagement/calendar.svg")}
                  alt="View"
                  title="View"
                  width="20px"
                  className="mr-2"
                />
                <div className="f16-700">
                  {" "}
                  {moment(
                    props.vendorOffer && props.vendorOffer.start_date
                  ).format("DD/MM/YYYY")}
                </div>
              </div>
            </Col>
            <Col xs={6} className="py-3 border-top">
              <div className="pb-2 f12-400 opacity5">Start Time</div>
              <div className="d-flex align-items-center">
                <div className="f16-700">
                  {" "}
                  {moment(
                    props.vendorOffer && props.vendorOffer.start_date
                  ).format("hh:mm A")}
                </div>
              </div>
            </Col>
            <Col xs={6} className="py-3 border-top border-right">
              <div className="pb-2 f12-400 opacity5">End Date</div>
              <div className="d-flex align-items-center">
                <Image
                  src={require("../../../assets/images/UserManagement/calendar.svg")}
                  alt="View"
                  title="View"
                  width="20px"
                  className="mr-2"
                />
                <div className="f16-700">
                  {" "}
                  {moment(
                    props.vendorOffer && props.vendorOffer.end_date
                  ).format("DD/MM/YYYY")}
                </div>
              </div>
            </Col>
            <Col xs={6} className="py-3 border-top">
              <div className="pb-2 f12-400 opacity5">End Time</div>
              <div className="d-flex align-items-center">
                <div className="f16-700">
                  {" "}
                  {moment(
                    props.vendorOffer && props.vendorOffer.end_date
                  ).format("hh:mm A")}
                </div>
              </div>
            </Col>
            <Col xs={6} className="py-3 border-top border-right">
              <div className="pb-2 f12-400 opacity5">Coupon Code</div>
              <div className="f16-700">
                {" "}
                {props.vendorOffer && props.vendorOffer.coupon_code}
              </div>
            </Col>
            <Col xs={6} className="py-3 border-top">
              <div className="pb-2 f12-400 opacity5">Maximum Usage Limit</div>
              <div className="f16-700">-</div>
            </Col>
            <Col xs={6} className="py-3 border-top border-right">
              <div className="pb-2 f12-400 opacity5">Views</div>
              <div className="f16-700">
                {props.vendorOffer && props.vendorOffer.offerViews}
              </div>
            </Col>
            <Col xs={6} className="py-3 border-top">
              <div className="pb-2 f12-400 opacity5">Used</div>
              <div className="f16-700">
                {props.vendorOffer && props.vendorOffer.offerUsed}
              </div>
            </Col>
            <Col xs={12} className="py-3 border-top">
              <div className="pb-2 f12-400 opacity5">
                Coupon Code Usage Limit
              </div>
              <div className="f16-700">-</div>
            </Col>
            <Col xs={12} className="py-3 border-top">
              <div className="pb-4">
                <div className="pb-2 f12-400 opacity5">View Offer Image</div>
                <div className="enIMG105">
                  <Image
                    src={
                      (props?.vendorOffer?.photo_thumbnails && props?.vendorOffer?.photo_thumbnails.length) ? props?.vendorOffer?.photo_thumbnails[0] : props?.vendorOffer?.photos[0]
                    }
                    alt="offer"
                    title="offer"
                    fluid
                    className="w-100 h-100"
                  />
                </div>
                <div className="pt-2 f12-400">
                  (You can upload only 1 pic per offer 700 x 420 pixels)
                </div>
              </div>
              <div className="pb-4">
                <div className="pb-2 f12-400 opacity5">View Video</div>
                <div className="enIMG105">
                  <Image
                    src={require("../../../assets/images/UserManagement/offer.png")}
                    alt="offer"
                    title="offer"
                    fluid
                    className="w-100 h-100"
                  />
                </div>
                <div className="pt-2 f12-400">
                  (You can upload only 1 pic per offer 700 x 420 pixels)
                </div>
              </div>
            </Col>
            <Col xs={12} className="py-3 border-top">
              <div className="f12-400 opacity5">Terms and Conditions</div>
              <div className="pt-2 f12-400">
                {props.vendorOffer && props.vendorOffer.terms_and_condition}
              </div>
            </Col>
          </Row>
          <div className="sectionHeader f12-700">More Details</div>
          <div className="d-flex border-bottom">
            <div className="col-6 py-3">
              <div className="f10-400 opacity5 pb-2">Offer ID</div>
              <div className="f12-500 c_black text-break">
                #{props.vendorOffer && props.vendorOffer._id}
              </div>
            </div>
            <div className="col-6 py-3">
              <div className="f10-400 opacity5 pb-2">Changed Date / Time</div>
              <div className="f12-500 c_black">
                {" "}
                {moment(
                  props.vendorOffer && props.vendorOffer.updatedAt
                ).format("Do MMMM YYYY")}
              </div>
              <div className="f12-500 c_black">
                {" "}
                {moment(
                  props.vendorOffer && props.vendorOffer.updatedAt
                ).format("hh:mm A")}
              </div>
            </div>
          </div>
          <div className="d-flex border-bottom">
            <div className="col-6 py-3">
              <div className="f10-400 opacity5 pb-2">Created Date / Time</div>
              <div className="f12-500 c_black">
                {moment(
                  props.vendorOffer && props.vendorOffer.createdAt
                ).format("Do MMMM YYYY")}
              </div>
              <div className="f12-500 c_black">
                {moment(
                  props.vendorOffer && props.vendorOffer.createdAt
                ).format("hh:mm A")}
              </div>
            </div>
            <div className="col-6 py-3">
              <div className="f10-400 opacity5 pb-2">Pont of Entry</div>
              <div className="f12-500 c_black">-</div>
            </div>
          </div>
          <div className="sectionHeader border-top-0 d-flex align-items-center justify-content-between f12-700">
            <span>View Audit Log</span>
            <Image
              src={require("../../../assets/images/UserManagement/up-arrow.svg")}
              alt="offer"
              title="offer"
              fluid
              width="15px"
              style={{ width: 15 }}
              className={`ml-2 ${!showLog ? "en180deg" : ""}`}
              onClick={handleShowLog}
            />
          </div>
          <div className="">
            {showLog && (
              <Table striped responsive className="mb-0">
                <thead className="audit-table-header">
                  <AuditLogsheaderTable
                    date="Date"
                    operation="Comments"
                    by="Comments By"
                  />
                </thead>
                <tbody>{renderAuditViewDetails()}</tbody>
              </Table>
            )}
          </div>
        </Modal>
      </React.Fragment>
    </>
  );
};

MobileViewOfferDetailsOffline.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(MobileViewOfferDetailsOffline);
